import { Moment } from 'moment';

import { ITokenResponse } from '../../services/authentication/authentication.service';

export const SISS_CLOUD_LOCALSTORAGE_CODE_KEY = '__siss_cloud_oauth2_code__';
export const SISS_CLOUD_LOCALSTORAGE_ERROR_KEY = '__siss_cloud_oauth2_error__';
export const SISS_CLOUD_LOCALSTORAGE_STATE_KEY = '__siss_cloud_oauth2_state__';
export const SISS_CLOUD_LOCALSTORAGE_TOKEN_KEY = '__siss_cloud_oauth2_token__';

export interface SissCloudAuthToken extends ITokenResponse {
    expirationDate: Moment;
    lastValidDate: Moment;
    refreshTimeout: any;
    userId: string;
}

export interface SissCloudExtraData {
    type: 'SissCloud';
    sessionId: string;
}

export function isSissCloudExtraData(data: unknown): data is SissCloudExtraData {
    return !!data && typeof data === 'object' && 'type' in data && data.type === 'SissCloud';
}

export class SissCloudInvalidTokenError extends Error {
    static ERROR_CODE = 'SISSUnauthorized';

    static guard(error: unknown) {
        if (error === SissCloudInvalidTokenError.ERROR_CODE) {
            throw new SissCloudInvalidTokenError();
        }
    }

    constructor() {
        super(SissCloudInvalidTokenError.ERROR_CODE);
    }
}

export class SissCloudInvalidUserError extends Error {
    static ERROR_CODE = 'SISSWrongSISSUser';

    static guard(error: unknown) {
        if (error === SissCloudInvalidUserError.ERROR_CODE) {
            throw new SissCloudInvalidUserError();
        }
    }

    constructor() {
        super(SissCloudInvalidUserError.ERROR_CODE);
    }
}
